export const RecommendationsEmptyState = (
    <svg
        width="234px"
        height="146px"
        viewBox="0 0 234 146"
        version="1.1"
    >
        <title>No recommendations</title>
        <desc>Created with Sketch.</desc>
        <g
            id="Page-3"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Artboard"
                transform="translate(-352.000000, -67.000000)"
            >
                <g
                    id="No-recommendations"
                    transform="translate(353.000000, 68.000000)"
                >
                    <path
                        d="M0,143 C6.22484536,130.874855 12.6030398,124.505663 23.7715358,124.132133 C37.5985205,123.669658 37.5,86.8636364 65.514053,95.1446341 C81.3318294,99.8203935 90.1703714,100.338924 102.990026,88.581286 C109.335644,82.7614041 124.802042,75.9931078 132.65138,78.5594856 C147.383942,83.3763996 147.951281,98.5031284 165.954175,101.666755 C175.220881,103.29518 185.071694,96.7696147 195.338969,100.70394 C207.285749,105.281835 199.192485,123.041702 214.089255,124.132133 C227.242458,125.094949 232,137.788887 232,143 L0,143 Z"
                        id="Fill-34-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#D4D8DC"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M121.038084,81 L162.381699,81.4599002 C162.517762,90.4842269 158.298012,108.818902 151.087628,112.311097 C147.320008,114.135866 144.711903,114.780869 140.696091,114.999043 C135.128346,115.088638 128.268242,108.866807 125.249202,103.866933 C122.73212,99.5797084 120.69369,86.215944 121.038084,81 Z"
                        id="Fill-5-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M158.098028,61.6875641 C151.526875,51.990464 160.129651,52.5202704 163.488137,46.8394144 C165.75291,43.0086236 164.241238,37.8730003 167.145708,34.3357315 C171.885421,28.5634134 181.809751,32.5870755 182.931043,39.4153817 C183.986558,45.8425186 177.560271,46.8197732 174.268354,50.1607143 C172.517668,51.9375255 170.168258,73.3514807 158.86801,61.8829644 L158.098028,61.6875641 Z"
                        id="Fill-6-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M147.771988,59.391137 C141.83111,60.8092168 137.532039,55.7144325 138.228722,50.5521132 C138.695136,47.0959511 142.227816,44.935754 141.720126,41.1740367 C141.254809,37.7258469 136.488229,36.09811 138.810662,31.7960368 C139.88306,29.8093914 142.874294,28.732589 143.233092,26.4063526 C143.69974,23.3808501 140.33005,21.4059332 140.789101,18.4296446 C141.236169,15.5312395 144.975778,14.8773545 146.37541,12.6087642 C149.121728,8.15728627 144.243145,-1.08487724 155.80221,0.104764329 C159.722589,0.508210657 164.619813,4.27675045 163.134182,8.40481205 C162.369828,10.5287504 159.684367,12.2198827 159.177226,14.3334723 C158.544298,16.9714732 161.470445,20.1101982 160.108251,22.6335967 C159.06961,24.55769 155.319662,25.6545764 154.987572,27.8076444 C154.485287,31.0640381 158.483597,33.3439737 157.431563,36.7545248 C156.48221,39.8320775 151.413537,40.5863067 150.79784,43.4377209 C149.724893,48.4068642 155.935515,55.0689797 149.634039,58.9600175 L147.771988,59.391137 Z"
                        id="Fill-7-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M153.586331,74.3643411 C156.921972,64.3628689 166.081963,51.7211975 173.928058,40.6899225"
                        id="Stroke-8-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M156.392086,6.31395349 C145.424627,27.5174993 144.467626,51.4756336 144.467626,75.0658915"
                        id="Stroke-9-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M129.02181,67.2824734 C116.643543,67.3106935 126.030421,60.3660571 116.090737,54.9356175 C108.449076,50.7605866 113.623686,48.569494 109.842154,44.7129477 C107.342612,42.1637538 102.295953,42.4464204 99.7750601,40.1326787 C96.8098181,37.4109078 99.6077329,34.0351117 97.7790471,31.2375961 C95.6657581,28.0047615 90.1052815,26.5366162 89.1872641,22.6744103 C88.1922746,18.4886807 92.875966,12.3854542 99.6014668,14.4431214 C105.156064,16.1426098 105.569392,21.0180274 108.974342,24.2011667 C111.348717,26.4208671 116.294191,26.3776066 119.128232,28.1840059 C123.151202,30.7483177 121.287086,34.1916405 123.988225,36.9463608 C125.761831,38.755086 128.963327,39.2821204 130.497198,41.393902 C132.881088,44.6760444 128.533057,47.6825752 130.497198,50.6871677 C131.487314,52.2019848 133.128327,53.4623554 134.228911,54.9356175 C137.352971,59.1172382 137.051581,67.3488372 128.587904,67.3488372 L129.02181,67.2824734 Z"
                        id="Fill-10-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M100.978417,25.255814 C117.813166,38.7672489 130.770889,57.0997146 133.244604,75.7674419"
                        id="Stroke-11-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M118.520151,75.2157626 C138.560953,74.9330207 137.98742,74.9508658 142.254219,75.1382843 C144.560191,75.2395262 161.447392,75.0209012 163.736707,75.3600479 C164.403394,75.4588685 164.00425,82.1511427 163.824414,82.9182133 C153.733398,83.2647133 119.674953,82.4477839 118.514388,81.6403601 L118.520151,75.2157626 Z"
                        id="Fill-12-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M161.466595,109.01717 C163.605529,109.104186 167.133776,108.616969 169.274304,108.735928 C170.330321,116.367645 169.160459,119.845842 169.276695,122.762167 C167.127798,122.723004 168.674329,122.91417 165.723407,122.807817 C159.443897,122.581281 150.300143,123.048549 144.020368,122.729123 C131.625206,122.098715 120.751868,123.00241 108.354581,122.452654 C107.810931,112.027609 108.011454,108.526037 108.121911,107.844961 L161.466595,109.01717 Z"
                        id="Fill-13-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M185.754769,131.864669 C185.818207,134.031199 185.850789,137.930315 185.852518,143.562016 L89.7339709,142.660248 C89.6120227,134.975252 89.6120227,130.942508 89.7339709,130.562016 L185.754769,131.864669 Z"
                        id="Fill-16-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M176.72011,121.362454 C176.750942,126.094399 176.72011,127.580426 176.72011,131.263566 C152.573628,131.263566 101.724413,130.842822 83.2792697,130.476404 C82.4704065,123.528006 82.768752,121.194172 82.9330941,120.74031 C145.457771,121.155072 176.72011,121.362454 176.72011,121.362454 Z"
                        id="Fill-15-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M163.406475,121.792636 L163.055755,131.263566"
                        id="Path-5"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#F5F9FD"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M152.008094,121.792636 L151.657374,131.263566"
                        id="Path-5-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#F5F9FD"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M115.533273,131.088178 L115.182554,141.912099"
                        id="Path-5-Copy-2"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#F5F9FD"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M101.504496,131.088178 L101.153777,141.912099"
                        id="Path-5-Copy-3"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#F5F9FD"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M48.3530811,118.251123 C42.1647552,118.993769 39.2621201,122.53773 40.159932,128.113492 C41.0521384,133.654443 44.8441604,136.469157 50.898234,135.936003 L53,135.750911 L52.5714267,131.120059 L50.4696607,131.305152 C46.7637947,131.63151 45.0898484,131.163189 44.5,127.5 C43.915757,123.871623 45.1190006,123.323968 48.9345449,122.866074 L51.0271065,122.614951 L50.4456427,118 L48.3530811,118.251123 Z"
                        id="Path-6-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M80.7600748,109.748821 C74.2603172,108.615652 49.0979939,108.900654 48,109.728861 C50.4551797,129.443566 51.676353,140.533946 51.6635199,143 L77.766099,143 C80.6170372,120.981569 81.6150292,109.897842 80.7600748,109.748821 Z"
                        id="Fill-48-Copy"
                        stroke="#D4D8DC"
                        strokeWidth="1.5"
                        fill="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M67.0561736,118.220303 C64.7495213,117.496821 63.4735009,118.685398 63.129957,119.899814 C62.6637187,121.553486 63.4489621,122.690386 65.5347647,124.369897 C68.0622667,126.411149 69.1174374,128.323208 68.3812718,130.958748 C68.1604221,131.733907 67.7923393,132.43155 67.3015622,133 C69.3382871,132.121487 71.0069292,130.312782 71.6940171,127.90979 C72.7737267,124.033995 70.9087738,119.97733 67.4733342,118.375335 C67.326101,118.323657 67.2034068,118.27198 67.0561736,118.220303 Z"
                        id="Path"
                        fill="#D4D8DC"
                    ></path>
                    <path
                        d="M63.7635587,125.852334 C61.3713258,123.868873 60.1396811,121.722387 60.8265598,119.086828 C60.9213017,118.706438 61.0634146,118.326048 61.2292129,118 C59.3817459,118.978145 57.9132464,120.825754 57.2974241,123.216776 C56.6579163,125.716481 57.0842548,128.270527 58.2448431,130.28116 C59.0501492,131.422329 59.8554554,132.291792 61.4423822,132.780865 C63.6214459,133.460133 65.3504855,132.509158 65.8478805,130.634379 C66.32159,128.868283 65.7057677,127.59126 63.7635587,125.852334"
                        id="Path"
                        fill="#D4D8DC"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);
